<template>
  <div class="text-left min-w-130">
    <div v-if="!checkIfMandateIsAbsent(mainMandate)">
      <appMultiselectOwners
        :options="addRepresentativesOptions"
        @onSelect="ADD_MANDATE"
        @onOpen="showSelect = true"
        @onClose="showSelect = false"
      />
    </div>
    <div
      v-if="mainMandate.presence_status == mandatePresenceStatuses.pouvoir_by_video_not_present_yet"
    >
      <appMultiselectOwners
        :options="assignRepresentativesOptions"
        @onSelect="ASSIGN_MANDATE"
        @onOpen="showSelect = true"
        @onClose="showSelect = false"
      />
    </div>
    <div v-for="mandate in representedMandates" :key="mandate.id">
      <!-- representing -->
      <b-card v-if="mandate.representant_owner_id !== mandate.building_owner_id" class="my-1">
        {{ getPersonNameAndGender({ personId: mandate.building_owner_id }) }}
        <!-- tantiemes -->
        <div>
          <b-badge>{{ getTotalMandateTantiemesChargeGenerale(mandate.id) }}</b-badge>
          <b-badge
            v-if="getReducedMandateTantiemesChargeGenerale(mandate.id)"
            class="ml-1"
            variant="warning"
          >
            {{ getReducedMandateTantiemesChargeGenerale(mandate.id) }}</b-badge
          >
        </div>
        <font-awesome-icon
          v-if="mandate.resolution_votes.length == 0"
          class="icon-click text-danger delete-mandate-button"
          icon="trash-alt"
          @click="REMOVE_MANDATE(mandate)"
        />
        <div
          v-else
          v-b-tooltip.hover
          class="text-secondary delete-mandate-button"
          title="Un vote a déjà été enregistré. Suppression impossible."
        >
          <font-awesome-icon icon="trash-alt" />
        </div>
        <font-awesome-icon
          v-if="representedMandates.length !== 1 && !checkIfMandateIsAbsent(mainMandate)"
          class="icon-click text-info mr-2"
          icon="share"
          @click="openModalAskMoveMandate(mandate.id)"
        />
        <font-awesome-icon
          v-if="
            mainMandate.presence_status != mandatePresenceStatuses.pouvoir_by_video_not_present_yet
          "
          class="icon-click text-dark"
          icon="calendar"
          @click="openModalChangeMandateDates(mandate.id)"
        />
        <!-- Modal Ask Move Mandate -->
        <b-modal
          v-if="showModalsAskMoveMandate[mandate.id]"
          :id="`modal-ask-move-mandate-${mandate.id}`"
          size="lg"
          hide-footer
          centered
          :visible="true"
          @hide="closeModalAskMoveMandate(mandate.id)"
        >
          <modalAskMoveMandate
            :options="moveMandateOptions"
            :mandate="mandate"
            @onSelect="MOVE_MANDATE($event, mandate)"
          />
        </b-modal>
        <!-- Modal Change Mandate Dates -->
        <b-modal
          v-if="showModalsChangeMandateDates[mandate.id]"
          :id="`modal-change-mandate-dates-${mandate.id}`"
          size="lg"
          hide-footer
          centered
          :visible="true"
          @hide="closeModalChangeMandateDates(mandate.id)"
        >
          <modalChangeMandateDates :mandate-id="mandate.id" />
        </b-modal>
      </b-card>
    </div>
  </div>
</template>

<script>
import appMultiselectOwners from "@/components/snippets/MultiselectOwners";
import modalAskMoveMandate from "@/components/b-table-components/modals/AskMoveMandate";
import modalChangeMandateDates from "@/components/b-table-components/modals/ChangeMandateDates";

import MandateMW from "@/middlewares/Mandate";
import MeetingMW from "@/middlewares/Meeting";

import MandateORM from "@/store/orm-axios/models/Mandate";
import MeetingORM from "@/store/orm-axios/models/Meeting";

import meetingDetailsMixin from "@/mixins/meeting-details";
import minutesMixin from "@/mixins/minutes";
import tablesMixins from "@/mixins/tables";
import meetingPresenceMixin from "@/mixins/meeting-presence";
import meetingPresenceSelectOptionsMixins from "@/mixins/meeting-presence-select-options";

export default {
  components: {
    appMultiselectOwners,
    modalAskMoveMandate,
    modalChangeMandateDates,
  },
  mixins: [
    meetingDetailsMixin,
    tablesMixins,
    meetingPresenceMixin,
    minutesMixin,
    meetingPresenceSelectOptionsMixins,
  ],
  props: {
    mainMandate: {
      type: Object,
      default: () => {
        return {};
      },
    },
    presenceMandates: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isVideoCase: {
      type: Boolean,
      default: false,
    },
    isDummyVideoCase: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showSelect: false,
      addRepresentativesOptions: [],
      showModalsChangeMandateDates: {},
      showModalsAskMoveMandate: {},
    };
  },
  computed: {
    meeting() {
      return MeetingORM.getters("getById")(this.$route.params.id);
    },
    representedMandates() {
      var items = this.$_.filter(this.presenceMandates, item => {
        if (this.mainMandate.representant_owner_id)
          return item.representant_owner_id == this.mainMandate.representant_owner_id;
        else if (this.mainMandate.representant_contact_id)
          return item.representant_contact_id == this.mainMandate.representant_contact_id;
      });

      // NOTE: show represented by himself first
      items = this.$_.sortBy(items, item => {
        return item.representant_owner_id !== item.building_owner_id;
      });

      return items;
    },
    // NOTE: options for multiselect (move mandate)
    moveMandateOptions() {
      return this.getBOsCsShowedUpNotAbsentGroupedOpts(this.mainMandate);
    },

    assignRepresentativesOptions() {
      return this.addRepresentativesOptions.filter(
        option => !this.representedMandates.find(m => m.id == option.mandate_id)
      );
    },
  },
  watch: {
    showSelect(val) {
      if (val) {
        var opts = this.getBOsShowedUpOrRepresentedAbsentOpts();

        if (this.votingLimitRules.votingLimitIsActive) {
          this.addRepresentativesOptions = this.getBOsNotShowedUpOrRepresentedAbsentRestrictedOpts(
            opts,
            this.mainMandate.representant_owner_id || this.mainMandate.representant_contact_id
          );
        } else {
          this.addRepresentativesOptions = opts;
        }
      } else {
        this.addRepresentativesOptions = [];
      }
    },
  },
  methods: {
    async ADD_MANDATE(selectedOption) {
      try {
        this.$store.state.showLoaderOverlay = true;

        var addedMandate = MandateORM.query()
          .where("meeting_id", this.mainMandate.meeting_id)
          .where("building_owner_id", selectedOption.id)
          .first();

        if (addedMandate.presence_status == this.mandatePresenceStatuses.correspondence) {
          await this.deleteVotesByCorrespondenceForResolutionsThatWereNotVoted(addedMandate);
        }

        var self = this;
        MandateORM.update({
          where: addedMandate.id,
          data(item) {
            item.dummy_video_presence_status = self.isDummyVideoCase ? 1 : 0;

            item.representant_contact_id = self.mainMandate.representant_contact_id;
            item.representant_owner_id = self.mainMandate.representant_owner_id;
            item.showed_up = 1;
            item.presence_status =
              self.isVideoCase || self.isDummyVideoCase
                ? self.mandatePresenceStatuses.pouvoir_by_video
                : self.mandatePresenceStatuses.pouvoir;
          },
        }).then(async updatedMandate => {
          await MandateMW.PUT(updatedMandate);
          await self.setMandateAddedEvent(updatedMandate.id, true);

          self.$store.state.showLoaderOverlay = false;
        });
      } catch (err) {
        console.error(err);
        this.$store.state.showLoaderOverlay = false;
        this.$swal(this.alertError());
      }
    },
    async ASSIGN_MANDATE(selectedOption) {
      try {
        this.$store.state.showLoaderOverlay = true;

        var assignedMandate = MandateORM.query()
          .where("meeting_id", this.meeting.id)
          .where("building_owner_id", selectedOption.id)
          .first();

        if (assignedMandate.presence_status == this.mandatePresenceStatuses.correspondence) {
          await this.deleteVotesByCorrespondenceForResolutionsThatWereNotVoted(assignedMandate);
        }

        var self = this;
        MandateORM.update({
          where: assignedMandate.id,
          data(item) {
            item.representant_contact_id = self.mainMandate.representant_contact_id;
            item.representant_owner_id = null;
            item.presence_status = self.mandatePresenceStatuses.pouvoir_by_video_not_present_yet;
          },
        }).then(async updatedMandate => {
          await MandateMW.PUT(updatedMandate, false);

          self.$store.state.showLoaderOverlay = false;
        });
      } catch (err) {
        console.error(err);
        this.$store.state.showLoaderOverlay = false;
        this.$swal(this.alertError());
      }
    },
    openModalAskMoveMandate(mandateId) {
      this.$set(this.showModalsAskMoveMandate, mandateId, true);
    },
    closeModalAskMoveMandate(mandateId) {
      this.$set(this.showModalsAskMoveMandate, mandateId, false);
    },
    openModalChangeMandateDates(mandateId) {
      this.$set(this.showModalsChangeMandateDates, mandateId, true);
    },
    closeModalChangeMandateDates(mandateId) {
      this.$set(this.showModalsChangeMandateDates, mandateId, false);
    },
    async MOVE_MANDATE(selectedOwnerOrContact, mandate) {
      this.$store.state.showLoaderOverlay = true;

      var self = this;
      this.$bvModal.hide(`modal-ask-move-mandate-${mandate.id}`);

      var mandateCopy = JSON.parse(JSON.stringify(mandate));

      if (mandateCopy.presence_status == self.mandatePresenceStatuses.correspondence) {
        await self.deleteVotesByCorrespondenceForResolutionsThatWereNotVoted(mandateCopy);
      }

      // representant id
      mandateCopy.representant_contact_id =
        selectedOwnerOrContact.type == "contact" ? selectedOwnerOrContact.id : null;
      mandateCopy.representant_owner_id =
        selectedOwnerOrContact.type == "owner" ? selectedOwnerOrContact.id : null;
      // presence status
      mandateCopy.presence_status =
        selectedOwnerOrContact.presenceType == "video"
          ? self.mandatePresenceStatuses.pouvoir_by_video
          : self.mandatePresenceStatuses.pouvoir;
      // dummy video
      mandateCopy.dummy_video_presence_status = selectedOwnerOrContact.hasDummyVideoPresenceStatus
        ? 1
        : 0;

      var moveFromRepresentantType = mandate.representant_owner_id ? "owner" : "contact";
      var moveFromRepresentantId = mandate.representant_owner_id
        ? mandate.representant_owner_id
        : mandate.representant_contact_id;
      var moveToRepresentantType = mandateCopy.representant_owner_id ? "owner" : "contact";
      var moveToRepresentantId = mandateCopy.representant_owner_id
        ? mandateCopy.representant_owner_id
        : mandateCopy.representant_contact_id;

      MandateMW.PUT(mandateCopy)
        .then(async () => {
          // NOTE: event mandate-moved
          await this.setMandateMovedEvent(mandateCopy.id, {
            moveFromRepresentantType,
            moveFromRepresentantId,
            moveToRepresentantType,
            moveToRepresentantId,
          });
          this.$nextTick(() => {
            MeetingMW.PUT(this.meeting)
              .then(() => {
                this.$store.state.showLoaderOverlay = false;
              })
              .catch(err => {
                this.$store.state.showLoaderOverlay = false;
                console.error(err);
              });
          });
        })
        .catch(err => {
          console.error(err);
          this.$store.state.showLoaderOverlay = false;
        });
    },
  },
};
</script>
